export default "__VITE_ASSET__CvvZfVfC__"